import React, { useState } from 'react';
import TechnicalFilm, { Film } from './TechnicalFilm';

const WORKBENCH: Film = {
    directory: 'workbench-study',
    name: 'Engineering workbench material study',
    title: <>The workbench, <em>in motion.</em></>,
    description: 'A closer look at the porcelain, graphite and copper connecting the three assemblies.',
    seconds: 8,
    posterAlt: 'Three enterprise cartridges, three agents within copper guardrails and a circuit board on a porcelain deck.',
    disclosure: 'AI-generated material study based on this site’s original procedural model; not live hardware.',
    transcript: [
        { time: '0:00 to 0:05.5', text: 'The camera moves around the connected workbench. Three enterprise cartridges, three guarded agent characters and a circuit board remain in view.' },
        { time: '0:05.5 to 0:08', text: 'A warm highlight crosses the copper connections, then the view settles.' },
    ],
};

export default function WorkbenchFilm() {
    const [open, setOpen] = useState(false);
    return <details className="forge-model__film" onToggle={event => setOpen(event.currentTarget.open)}>
        <summary>Watch the material study · 8 seconds</summary>
        {open && <TechnicalFilm film={WORKBENCH} inline />}
    </details>;
}
